// Module
var code = "<div> <ul class=\"region-switcher\"> <li ng-repeat=\"region in regions track by region.url\" ng-class=\"{selected: region.selected, secondary: !region.isPrimary}\"><a ng-href=\"{{ region.url }}\" ng-bind=\"region.desc\"></a></li> </ul> </div> ";
// Exports
var _module_exports =code;;
var path = '/codebuild/output/src974318165/src/frontend/js/directives/public/regionSwitcher.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;